import React from "react";
import { Rocket } from "lucide-react";
import PageHeader from "components/ui/PageHeader";

const LaunchHeader: React.FC = () => (
    <PageHeader
        icon={<Rocket className="w-5 h-5" />}
        iconBg="bg-blue-50 dark:bg-blue-900/20"
        iconColor="text-blue-600 dark:text-blue-400"
        accentColor="bg-gradient-to-r from-blue-500 to-indigo-500"
        title="Launch Template"
        subtitle="Configure your campaign details and send to your audience instantly"
    />
);

export default LaunchHeader;
